// @vendors
const get = require('lodash/object/get');
const momentTz = require('moment-timezone');
const Immutable = require('immutable');

// @actions
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');

const {
    FIRST_STEP,
    SECOND_STEP,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    EURO_TEXT,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID,
    BROKER_STOCKS_BUY_NO_RESTRICTION,
    BROKER_ALERT_BUY_BUTTON_STOCK,
    SPANISH_MARKETS_ISO_CODE,
    CHARGE_ACCOUNT_PREFIX,
    INTERVENER_TYPE_PROPIETARIO,
    BROKER_ORDER_TYPE_SELL,
    BROKER_PRODUCT_TYPE_STOCKS,
    API_CHANNEL,
} = require('constants/index');

const { SELL_STOCKS_SHOW_COST } = require('constants/flagBasedFeatures');

const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');

function reset() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillLeave() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_WILL_LEAVE
    };
}

function setSellContract(contract) {
    return {
        type: actionTypes.BROKER_SELL_CONTRACT_NUMBER,
        payload: {
            contract: contract
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(step, catalogData) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_VALIDATE_STEP,
        payload: {
            step,
            catalogData
        }
    };
}

function setCodes(emisionCode, valueCode) {
    return {
       type: actionTypes.BROKER_STOCKS_SELL_SET_CODES,
       payload: {
           emisionCode,
           valueCode
       }
   }
}

function validateWithAPISuccess(response) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_VALIDATE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function validateWithAPIFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_VALIDATE_FAILURE,
        payload: {
            data: response
        }
    };
}

function validateWithAPIRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_VALIDATE_REQUEST
    };
}

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_STOCKS_BUY_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

function confirmStocksSellSuccess(response) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_CONFIRM_SUCCESS,
        payload: {
            data: response
        }
    };
}

function confirmStocksSellFailure(response) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

function confirmStocksSellRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_CONFIRM_REQUEST
    };
}

function stocksSellFinish(response) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_FINISH,
        payload: {
            data: get(response, 'timestamp', '')
        }
    }
}

function getValidationData(getState) {
    const validationData = {
        descripcionRestriccion: BROKER_STOCKS_BUY_NO_RESTRICTION,
        tipoNegociacion: '0',
        tipoRestriccion: '0'
    };

    const orderTypes = {};

    orderTypes[BROKER_ORDER_TYPE_FOR_THE_BEST] = {
        code: FOR_THE_BEST_CODE,
        orderDescription: BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_LIMITED] = {
        code: LIMITED_CODE,
        orderDescription: BROKER_ORDER_TYPE_LIMITED_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_TO_MARKET] = {
        code: TO_MARKET_CODE,
        orderDescription: BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION
    };

    const operationFirstStep = getState()['brokerStocksSell'].getIn(['steps', FIRST_STEP]);
    const orderType = operationFirstStep.get('orderTypeOption');
    const validityDate = operationFirstStep.get('validityDate');
    const titleQuantity = operationFirstStep.get('titleQuantity');

    validationData['importeAprximado'] = {
        divisa: EURO_TEXT,
        importe: 0
    };

    const currency = getState().brokerProductFile.get('currency');

    if (orderType === BROKER_ORDER_TYPE_LIMITED) {
        validationData['importeLimitada'] = {
            divisa: currency,
            numeroimportevalores: operationFirstStep.get('orderTypeValue')
        };
    } else {
        validationData['importeLimitada'] = {
            divisa: currency,
            numeroimportevalores: 0
        };
    }
    validationData['numTitulos'] = titleQuantity;
    validationData['tipoOrden'] = orderTypes[orderType].code;
    validationData['descripcionOrden'] = orderTypes[orderType].orderDescription;
    validationData['plazoValidez'] = validityDate.format('YYYY-MM-DD');

    return validationData;
}

const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
        ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
        : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

function sendOrderSummaryRequest() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_SEND_ORDER_SUMMARY_REQUEST,
    };
}
function sendOrderSummarySuccess() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_SEND_ORDER_SUMMARY_SUCCESS,
    };
}
function sendOrderSummaryError() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_SEND_ORDER_SUMMARY_ERROR,
    };
}

const sendOrderSummary = (response) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const immBrokerStocksSell = getState().brokerStocksSell;
    const dataValidation = getValidationData(getState);
    const selectedOption = immBrokerStocksSell.getIn(['steps', FIRST_STEP, 'selectedOptionValue']);
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });
    const contractNumber = contract.get('walletNumber');
    const productNumber = contract.get('productNumber');
    const controlDigit = contract.get('controlDigit');
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${contractNumber}`;
    const operationFirstStep = getState()['brokerStocksBuy'].getIn(['steps', FIRST_STEP]);
    const shareNumber = dataValidation.numTitulos;
    let currency, amount;
    if (!!immBrokerStocksSell.get('estimatedBaseAmount')){
        amount = immBrokerStocksSell.getIn(['estimatedBaseAmount', 'amount'])
        currency = immBrokerStocksSell.getIn(['estimatedBaseAmount', 'currency'])
    } else {
        amount = immBrokerStocksSell.getIn(['steps', FIRST_STEP, 'selectedOptionTitles']);
        currency = get(response, ['datosCuentaAsociada', 'saldoCuentaAsociada', 'divisa'], '');
    }
    const marketName = getState().brokerProductFile.get('marketName');
    const emittedDateTime = momentTz(parseInt(get(response, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    const conditionPrice =
        !!operationFirstStep.get("orderType") &&
        operationFirstStep.get("orderType") === "limited"
            ? operationFirstStep.get("orderTypeLimited")
            : "";
    const exAnteData = !!immBrokerStocksSell.get("exAnteData")
        ? translateExantCostKey(
            immBrokerStocksSell.get("exAnteData").toJS(),
            "brokerStocksSells"
        ) : null;
    communicationServiceInput = {
        "email": PersonalDataHelper.getEmail(immProfile),
        "productKID": "",
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "sendOrder": "No",
        "ccc": get(response, ['datosCuentaAsociada', 'codIban', 'codbban'], '').trim(),
        "ccv": securityAccount,
        "idContract": securityAccount,
        "conditionPrize": "" + conditionPrice + "",
        "currency": currency,
        "holders": holderNames.join(','),
        "idOrder": get(response, 'numeroOrden', ''),
        "isin": getState().brokerProductFile.get('isinCode'),
        "isinDescribe": getState().brokerProductFile.get('companyName'),
        "market": marketName,
        "orderCondition": dataValidation.descripcionOrden,
        "orderType": BROKER_ORDER_TYPE_SELL,
        "productType": BROKER_PRODUCT_TYPE_STOCKS,
        "sharesAmount": amount,
        "sharesNumber": "" + shareNumber + "",
        "termValidity": dataValidation.plazoValidez,
        "clientAlias": immProfile.get('nombreCliente'),
        "channel": __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime": emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        "exAnteCostsList": exAnteData,
    };

    data = {
        query: communicationServiceInput
    };

    dispatch(sendOrderSummaryRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data).then(
        function () {
            dispatch(sendOrderSummarySuccess());
        },
        function () {
            dispatch(sendOrderSummaryError());
        }
    );
}

const confirmStocksSell = (history) => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immStocksSellStep1 = getState().brokerStocksSell.getIn(['steps', FIRST_STEP]);
    const valid = getState().brokerStocksSell.getIn(['steps', SECOND_STEP, 'valid']);
    const dataToken = getState().brokerStocksSell.get('token');
    const confirmationData = getState().brokerStocksSell.get('confirmationData');
    const executionData = confirmationData.datosEjecucion;
    const selectedOption = immStocksSellStep1.get('selectedOptionValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });

    if (!contract) {
        return;
    }

    const emisionCode = getState().brokerStocksSell.get('emisionCode');
    const valueCode = getState().brokerStocksSell.get('valueCode');
    const immBrokerProductFile = getState().brokerProductFile;
    const isinCode = immBrokerProductFile.get('isinCode');
    const micCode = immBrokerProductFile.get('micCode');
    const shares = immStocksSellStep1.get('titleQuantity');
    const isSpain = SPANISH_MARKETS_ISO_CODE.includes(micCode.toLowerCase());
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', BROKER_CONVENIENCE_MIFID_TEST_STOCKS_ID, 'codigoDisclaimer']);
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    let data = {
        contratoValores: {
            numerodecontrato: contract.get('walletNumber'),
            producto: contract.get('productNumber')
        },
        dataToken: dataToken,
        datosEjecucion: {
            codigoGrupoSector: executionData.codigoGrupoSector,
            codigoOrganismoEjecucion: executionData.codigoOrganismoEjecucion,
            codigoValorJuntSind: executionData.codigoValorJuntSind,
            codvalorSib: executionData.codvalorSib,
            indicadorCompensacion: executionData.indicadorCompensacion,
            indicadorContingencia: executionData.indicadorContingencia,
            indicadorEnvioRecepcion: executionData.indicadorEnvioRecepcion,
            nominalTitulo: {
                divisa: executionData.nominalTitulo.divisa,
                importe: executionData.nominalTitulo.importe
            },
            tipoCotizacion: executionData.tipoCotizacion,
            tipoMercado: executionData.tipoMercado,
            tipoOperacion: 'V',
            titulosNominalMinEjec: 0,
            tratamientoEmision: executionData.tratamientoEmision
        },
        datosEmision: {
            codEmision: emisionCode,
            codMercado: confirmationData.codMercado,
            codValor: valueCode
        },
        datosValidacion: getValidationData(getState),
        "convenienceTest": codigoDisclaimer,
        "productIsin": isinCode,
        "productType": BROKER_ALERT_BUY_BUTTON_STOCK,
        "shares": shares,
        "unitPrice": immBrokerProductFile.get('buyPrice'),
        "productManager": immBrokerProductFile.get('companyName'),
        "micCode": micCode,
        "initQuantity": shares,
        "disclaimers": {
            "disclaimer_1": "",
            "disclaimer_2": "",
            "disclaimer_3": "",
            "disclaimer_4": "",
            "disclaimer_5": ""
        },
        "convenientRegistry": false,
        "evaluateRegistry": false,
        "marketTargetRegistry": false,
        "necessaryConvenienceTestNote": 0,
        "necessaryTargetMarketNote": "",
        "testConveniencyResult": 0,
        "documentationId": uuid
    };
    if (isSpain) {
        data.datosEjecucion['codigoBolsa'] = '1';
    }

    const requestData = {
        header: {
            version: 2
        },
        query: data
    };

    if (valid) {
        dispatch(confirmStocksSellRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('confirmStocksBuySell'), requestData).then(
            function(response) {
                dispatch(confirmStocksSellSuccess(response));
                dispatch(stocksSellFinish(response));
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
                if(immFlagBasedFeatures.get(SELL_STOCKS_SHOW_COST)) {
                    dispatch(sendOrderSummary(response));
                }
            },
            function(response) {
                dispatch(confirmStocksSellFailure(response));
                dispatch(brokerStocksOperationFailure(response, history));
            }
        );
    }
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(signaturePatternSuccess(dataToken));
        dispatch(confirmStocksSell(history));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

function stockContractChanged(value, titles) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_STOCK_CONTRACT_CHANGED,
        payload: {
            value,
            titles
        }
    };
}

function validityDateChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
}

function orderTypeChanged(value) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_ORDER_TYPE_CHANGED,
        payload: {
            value
        }
    };
}

function limitedValueChanged(value, sellPrice) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_LIMITED_VALUE_CHANGED,
        payload: {
            value,
            sellPrice
        }
    };
}

function titleQuantityChanged(value, manually) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_TITLE_QUANTITY_CHANGED,
        payload: {
            value,
            manually
        }
    };
}


const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const validateWithAPI = (history) => (dispatch, getState) => {
    let requestData, data;
    const immStocksSellStep1 = getState().brokerStocksSell.getIn(['steps', FIRST_STEP]);
    const selectedOption = immStocksSellStep1.get('selectedOptionValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });

    if (!contract) {
        return;
    }

    const contractNumber = contract.get('walletNumber');

    const valid = getState().brokerStocksSell.getIn(['steps', FIRST_STEP, 'valid']);
    const validSecondStep = getState().brokerStocksSell.getIn(['steps', SECOND_STEP, 'valid']);

    if (valid && validSecondStep) {
        dispatch(finish(history));
        return;
    } else if (!valid || validSecondStep) {
        return;
    }

    const controlDigit = getState().brokerStocksContract
        .find(wallet => wallet.get('walletNumber') === contractNumber)
        .get('controlDigit');

    const emisionCode = getState().brokerStocksSell.get('emisionCode');
    const valueCode = getState().brokerStocksSell.get('valueCode');

    requestData = {
        codEmision: emisionCode,
        codValor: valueCode,
        contratoValores: {
            numerodecontrato: contractNumber,
            producto: contract.get('productNumber')
        },
        datosValidacion: getValidationData(getState),
        digitoControl: controlDigit,
        tipoOperacion: 'V'
    };

    data = {
        query: requestData
    };

    dispatch(validateWithAPIRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('sellStocks'), data).then(
        function(response) {
            dispatch(validateWithAPISuccess(response));
        },
        function(response) {
            dispatch(validateWithAPIFailure(response));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
};

const validateStep = (step, history) => (dispatch, getState) => {
    const catalogData = getState().brokerProductFile.get('catalogData');
    dispatch(validateUIStep(step, catalogData));
    dispatch(validateWithAPI(history));
};

function getExAnteDataSuccess(response) {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_EX_ANTE_SUCCESS,
        payload: {
            data: response
        }
    };
}
function getExAnteDataFailure() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_EX_ANTE_FAILURE,
    };
}
function getExAnteDataFetching() {
    return {
        type: actionTypes.BROKER_STOCKS_SELL_EX_ANTE_FETCHING,
    };
}

const getExAnteData = (history) => (dispatch, getState) => {
    const immStocksSellStep1 = getState().brokerStocksSell.getIn(['steps', FIRST_STEP]);
    const immBrokerProductFile = getState().brokerProductFile;
    const selectedOption = immStocksSellStep1.get('selectedOptionValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });
    const contractNumber = contract.get('walletNumber');
    const isinCode = immBrokerProductFile.get('isinCode');
    const shares = immStocksSellStep1.get('titleQuantity');
    const orderTypeOption = immStocksSellStep1.get('orderTypeOption');
    const productCurrency = immBrokerProductFile.get('currency');
    let limitedPrice, orderType;
    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_TO_MARKET:
            limitedPrice = null;
            orderType = "MARKET";
            break;
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            limitedPrice = null;
            orderType = "BEST";
            break;
        case BROKER_ORDER_TYPE_LIMITED:
        default:
            limitedPrice = {
                amount: immStocksSellStep1.get("orderTypeValue"),
                currency: productCurrency,
            }
            orderType = "LIMITED";
        break;
    }
    const requestData = {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contract: {
            number: contractNumber,
            product: contract.get('productNumber'),
        },
        instrumentType: 'STOCK',
        isin: isinCode,
        limitedPrice: limitedPrice,
        market: immBrokerProductFile.get('micCode'),
        operationType: 'V',
        orderType: orderType,
        sharesAmount: null,
        sharesNumber: shares,
    };

    const data = {
        query: requestData
    }

    dispatch(getExAnteDataFetching());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), data)
        .then(response => dispatch(getExAnteDataSuccess(response)))
        .catch(error => {
            const errorKey = get(error, ['body', 'error'], '');
            dispatch(getExAnteDataFailure(error));
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        })
}

module.exports = {
    reset,
    setVisibleStep,
    setWillLeave,
    setWillCancel,
    setCodes,
    validateStep,
    finish,
    stockContractChanged,
    validityDateChanged,
    orderTypeChanged,
    limitedValueChanged,
    titleQuantityChanged,
    setSellContract,
    getExAnteData
};
